import React, { useCallback } from 'react';
import {
  ScrollView,
  StatusBar,
  TouchableOpacity,
  View,
  Text,
  Image,
  Linking,
  SafeAreaView,
  Platform,
} from 'react-native';
import PinkPhone from '~/credsystem/assets/imgs/pinkPhone.png';
import colors from '~/assets/themes/colors';
import { ContactCard } from './components/ContactCard';
import CleoAvatar from '~/credsystem/assets/imgs/cleo.png';
import { stringToCapitalCase } from '~/utils/string';
import WhatsAppIcon from '~/credsystem/assets/imgs/whatsAppWhite.png';
import usecredsystemDataStore from '~/credsystem/stores/credsystemData';
import CloseSVG from '~/assets/svgs/close.svg';
import useAppNavigation from '~/hooks/useAppNavigation';
import { callNumber, openEmail } from '~/utils/device';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import DefaultScreenContainerView from '~/components/DefaultScreenContainerView';

const CREDSYSTEM_CARD_SAC_CAPITAL = '4003-3900';
const CREDSYSTEM_CARD_SAC_OTHERS = '0800-729-3900';
const CREDSYSTEM_CARD_OMBUDSMAN = '0800-777-5297';
const CLEO_WHATSAPP_NUMBER = 551140033900;

const SAC: React.FC = () => {
  const firstName =
    usecredsystemDataStore.getState().credsystemCardInfo?.holder;
  const { goBack } = useAppNavigation();

  const handleCallPhone = useCallback((tel: string) => callNumber(tel), []);

  const handleOpenWhatsApp = useCallback((contact: number) => {
    if (Platform.OS === 'web') {
      const url = `https://web.whatsapp.com/send?phone=${contact}`;
      window.open(url, '_blank');
    } else {
      Linking.canOpenURL(`whatsapp://send?phone=${contact}`)
        .then((supported) => {
          if (supported) {
            return MarisaAppUtils.openUrl(`whatsapp://send?phone=${contact}`);
          } else {
            return MarisaAppUtils.openUrl(
              `https://api.whatsapp.com/send?phone=${contact}`
            );
          }
        })
        .catch(() => {
          return MarisaAppUtils.openUrl(
            `https://api.whatsapp.com/send?phone=${contact}`
          );
        });
    }
  }, []);

  return (
    <SafeAreaView className="flex-1 bg-light-100">
      <StatusBar barStyle="dark-content" backgroundColor={colors.light[100]} />
      <DefaultScreenContainerView>
        <View className="m-6 flex-1 bg-light-100">
          <View className="mb-6 flex-row justify-between">
            <Text className="text-[22px]">
              Preciso de{' '}
              <Text className="font-medium text-primary-600">Ajuda</Text>
            </Text>
            <TouchableOpacity onPress={goBack}>
              <CloseSVG
                className="self-center"
                height={24}
                width={24}
                color={colors.gray[400]}
              />
            </TouchableOpacity>
          </View>
          <ScrollView
            contentContainerStyle={{
              paddingBottom: 18,
            }}
            showsVerticalScrollIndicator={false}
          >
            <View>
              <ContactCard icon={CleoAvatar} center iconW={64} iconH={64}>
                <TouchableOpacity>
                  <Text className=" font-bold  text-primary-600">Cleo</Text>
                </TouchableOpacity>
                <Text className="text-xs text-gray-600 items-center justify-center mb-3">
                  (assistente virtual)
                </Text>
                <Text className="text-sm text-gray-600 items-center justify-center">
                  {firstName
                    ? `Olá, ${stringToCapitalCase(firstName.split(' ')[0])}! `
                    : 'Olá! '}
                  Posso te ajudar?
                </Text>
              </ContactCard>
              <TouchableOpacity
                className="rounded-lg flex-row p-[11px] justify-center items-center mt-3 bg-credsystem-whatsAppGreen"
                onPress={() => handleOpenWhatsApp(CLEO_WHATSAPP_NUMBER)}
              >
                <Image
                  source={WhatsAppIcon}
                  style={{ height: 22, width: 22 }}
                />
                <Text className="text-light-100 ml-[6px] text-xs font-medium">
                  FALAR COM A CLEO
                </Text>
              </TouchableOpacity>
              <Text className="text-sm text-gray-600 mt-8 text-left">
                Não conseguiu resolver o seu problema com a Cleo? Então envie
                e-mail para:
              </Text>
              <Text
                className="font-bold text-primary-500"
                onPress={() => openEmail(' atendimento@credsystem.com.br')}
              >
                atendimento@credsystem.com.br
              </Text>
            </View>
            <Text className="mt-7 text-gray-600">CARTÕES MARISA</Text>
            <ContactCard icon={PinkPhone} center>
              <Text className="text-sm text-dark-600">Telefone</Text>
              <View className="mb-1">
                <Text className="text-sm text-gray-500 items-center justify-center">
                  Capitais e regiões metropolitanas:{' '}
                </Text>
                <TouchableOpacity
                  onPress={() => handleCallPhone(CREDSYSTEM_CARD_SAC_CAPITAL)}
                >
                  <Text className="font-bold text-sm  text-primary-600">
                    {CREDSYSTEM_CARD_SAC_CAPITAL}
                  </Text>
                </TouchableOpacity>
              </View>
              <View className="mb-1">
                <Text className="text-sm text-gray-500 items-center justify-center">
                  Demais:{' '}
                </Text>
                <TouchableOpacity
                  onPress={() => handleCallPhone(CREDSYSTEM_CARD_SAC_OTHERS)}
                >
                  <Text className="font-bold  text-sm  text-primary-500 text-left">
                    {CREDSYSTEM_CARD_SAC_OTHERS}
                  </Text>
                </TouchableOpacity>
              </View>
            </ContactCard>
            <ContactCard icon={PinkPhone} center>
              <Text className="text-sm text-dark-600">Ouvidoria</Text>
              <View className="mb-1">
                <TouchableOpacity
                  onPress={() => handleCallPhone(CREDSYSTEM_CARD_OMBUDSMAN)}
                >
                  <Text className="font-bold  text-sm  text-primary-500">
                    {CREDSYSTEM_CARD_OMBUDSMAN}
                  </Text>
                </TouchableOpacity>
              </View>
              <Text className="text-xs text-gray-600 items-center justify-center ">
                Segunda à sábado das 8h as 22h
              </Text>
              <Text className="text-xs text-gray-600 items-center justify-center ">
                Domingo e feriados das 9h às 20h
              </Text>
            </ContactCard>
          </ScrollView>
        </View>
      </DefaultScreenContainerView>
    </SafeAreaView>
  );
};

export default SAC;
